
import { Fragment, h } from 'preact';
import { Price } from '@searchspring/snap-preact-components';

export function Prices ({ priceRange, core, subProps }) {
	let decimalPlaces = 0;
	let corePrice = String(core.price);
	let msrpPrice = String(core.msrp);
	const currencySymbol = window.Resources.shopCurrencySymbol;

	if (corePrice.includes('.') || msrpPrice.includes('.')) {
		decimalPlaces = 2;
	}

	if (priceRange) {
		let priceRange1 = String(priceRange[1]);
		let priceRange2 = String(priceRange[0]);

		if (priceRange1.includes('.') || priceRange2.includes('.')) {
			decimalPlaces = 2;
		}

		return (
			<>
				<Price symbol={currencySymbol} {...subProps.price} value={Number(priceRange[1])} decimalPlaces={decimalPlaces} />
				<span class="em-dash">&#8211;</span>
				<Price symbol={currencySymbol} {...subProps.price} value={Number(priceRange[0])} decimalPlaces={decimalPlaces} />
			</>
		);
	}

	//otherwise, return core price
	return (
		<>
			{core.price < core.msrp ? (
				<>
					<Price symbol={currencySymbol} {...subProps.price} value={core.msrp} lineThrough={true} decimalPlaces={decimalPlaces} />
					&nbsp;
					<Price symbol={currencySymbol} {...subProps.price} value={core.price} decimalPlaces={decimalPlaces} />
				</>
			) : (
				<Price symbol={currencySymbol} {...subProps.price} value={core.price} decimalPlaces={decimalPlaces} />
			)}
		</>
	);
}
